import React from 'react';
import styles from './Courses.module.css';
import { useNavigate } from 'react-router-dom';
import Ai from '../../assets/AI.jpg';
import Cybersecurity from '../../assets/CyberSecurity.jpg';
import Gamedev from '../../assets/GameDev.jpg';
import Fullstack from '../../assets/Fullstack.jpg';


const Courses: React.FC = () => {
  const navigate = useNavigate();

  const courses = [
    {
      id: 1,
      title: 'Cybersecurity',
      description: 'Master ethical hacking, network security, and penetration testing',
      duration: '12 Weeks',
      level: 'Advanced',
      image: Cybersecurity
    },
    {
      id: 2,
      title: 'Artificial Intelligence',
      description: 'Learn machine learning, neural networks, and AI applications',
      duration: '16 Weeks',
      level: 'Intermediate',
      image: Ai
    },
    {
      id: 3,
      title: 'Game Development',
      description: 'Build games using Unity and Unreal Engine',
      duration: '10 Weeks',
      level: 'Beginner',
      image: Gamedev
    },
    {
      id: 4,
      title: 'Full Stack Development',
      description: 'Become proficient in frontend and backend technologies',
      duration: '14 Weeks',
      level: 'Intermediate',
      image: Fullstack
    }
  ];

  return (
    <div className={styles.coursesPage}>
      <div className={styles.header}>
        <h1>Our <span>Courses</span></h1>
        <p>Choose your path to tech mastery</p>
      </div>
      
      <div className={styles.coursesGrid}>
        {courses.map((course) => (
          <div key={course.id} className={styles.courseCard}>
            <div className={styles.imageContainer}>
              <img src={course.image} alt={course.title} />
            </div>
            <div className={styles.courseInfo}>
              <h3>{course.title}</h3>
              <p>{course.description}</p>
              <div className={styles.meta}>
                <span>{course.duration}</span>
                <span>{course.level}</span>
              </div>
              <button 
                className={styles.enrollButton}
                onClick={() => navigate(`/courses/${course.id}`)}
              >
                Learn More
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Courses;